import { render, staticRenderFns } from "./edit-template.vue?vue&type=template&id=cfa80c86"
import script from "./edit-template.vue?vue&type=script&lang=js"
export * from "./edit-template.vue?vue&type=script&lang=js"
import style0 from "./edit-template.vue?vue&type=style&index=0&id=cfa80c86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports